import React from 'react'
import { Nav, TabContent } from 'reactstrap'
import { Redirect, Route, Switch } from 'react-router-dom'
import PropTypes from 'prop-types'
import MergeContainer from '../merge/MergeContainer'
import MergeSiteContainer from '../mergeSite/MergeSiteContainer'
import PacingContainer from '../pacing/PacingContainer'
import SSOToolContainer from '../sso-tool/SSOToolContainer'
import RosterLayout from '../roster/RosterContainer'
import SitePreferencesContainer from '../sitePreferences/SitePreferencesContainer'

import AdminNavBarItem from 'components/AdminNavBarItem'

export default function UtilitiesLayout(props) {
  return (
    <React.Fragment>
      <Nav tabs>
        <AdminNavBarItem
          endpoint={props.match.path + '/merge'}
          id="merge"
          name="Merge NSCustomers"
        />
        <AdminNavBarItem
          endpoint={props.match.path + '/ssotool'}
          id="ssotool"
          name="SSO Tool"
        />
        {/* <AdminNavBarItem
          endpoint={props.match.path + '/deleteuser'}
          id="deleteuser"
          name="Delete User"
        /> */}
        <AdminNavBarItem
          endpoint={props.match.path + '/roster'}
          id="roster"
          name="Bulk License Assignment"
        />        
         <AdminNavBarItem
          endpoint={props.match.path + '/mergeSite'}
          id="mergeSite"
          name="Merge Sites"
        />
        <AdminNavBarItem
          endpoint={props.match.path + '/sitePreferences'}
          id="sitePreferences"
          name="Site Preferences"
        />
        <AdminNavBarItem
          endpoint={props.match.path + '/pacing'}
          id="pacing"
          name="Pacing"
        />
      </Nav>
      <TabContent className="tab-content-bordered">
        <Switch>
          <Route
            component={MergeContainer}
            path={`${props.match.path}/merge`}
          />
          <Route
            component={SSOToolContainer}
            path={`${props.match.path}/ssotool`}
          />
          {/*  <Route
            component={DeleteUserContainer}
            path={`${props.match.path}/deleteuser`}
          /> */}
          <Redirect
            exact
            from={`${props.match.path}`}
            to={`${props.match.path}/merge`}
          />
          <Route
            component={MergeSiteContainer}
            path={`${props.match.path}/mergeSite`}
          /> 
          <Route
            component={PacingContainer}
            path={`${props.match.path}/pacing`}
          />
          <Route component={RosterLayout} path={`${props.match.path}/roster`} />
          <Route
            component={SitePreferencesContainer}
            path={`${props.match.path}/sitePreferences`}
          />
        </Switch>
      </TabContent>
    </React.Fragment>
  )
}

UtilitiesLayout.propTypes = {
  match: PropTypes.shape({
    path: PropTypes.string,
  }),
}



// WEBPACK FOOTER //
// ./src/containers/css-admin/utilities/UtilitiesLayout.js